<div class="trainer-card" *ngIf="!inline">
    <div class="profil">
        <div *ngIf="trainer.picturePath"
             class="img-circle"
             [ngStyle]="{'background':'url('+trainer.picturePath+'?sz=100) no-repeat center center / cover'}"></div>

        <div *ngIf="!trainer.picturePath"
             class="no-img"></div>

        <i *ngIf="trainer.active" class="active-icon fa fa-check-circle-o" aria-hidden="true"></i>
    </div>
    <br>
    <span class="name">{{trainer.firstName}} {{ trainer.lastName}}</span>
    <br>
    <span class="agency">{{trainer.companyName}}</span>
    <br>
    <div class="list-skill">
        <label-skill [mustDisplayGiven]="true" [mustDisplayFollowed]="true" [mustDisplayWished]="true"
                     [mustDisplayCan]="true" [mustDisplayRefuse]="true"
                     [skills]="trainer.trainerSkills"></label-skill>
    </div>
</div>
<div class="trainer-inline" *ngIf="inline">
    <div class="trainer-name">
        {{trainer.firstName}} {{trainer.lastName}} <span *ngIf="!trainer.active">({{'session-details.inactive' | translate}})</span>
    </div>
    <div class="trainer-company">
        {{trainer.companyName}}
    </div>
    <div class="trainer-skills">
        <label-skill [mustDisplayGiven]="true" [mustDisplayFollowed]="true"
            [mustDisplayWished]="true" [mustDisplayCan]="true"
            [mustDisplayRefuse]="true"
            [skills]="trainer.trainerSkills"></label-skill>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainer-card/trainer-card.component.html